export default "__VITE_ASSET__CPy8Vw6x__"